//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchDisplayBusinessName,
  fetchContactPreferences,
  fetchAddressDetails,
  updateAddressDetails,
  updateEmailDetails,
  fetchEmailDetails,
  fetchPhoneDetails,
  updatePhoneDetails,
  updatePreferredLangDetails,
  fetchStatementPrefDetails,
  updateStatementPrefDetails,
  fetchSecureMessage,
  updateSecureMessage,
  fetchSecureMessageOptions,
  fetchSecureMessageDetails,
} from '../api'; // Import the API function
import {
  addressInfoFetched,
  addressInfoFetchFailed,
  addressInfoRequest,
  contactInfoFetched,
  contactInfoFetchFailed,
  contactInfoRequest,
  displayBusinessNameRequest,
  displayBusinessNameFetched,
  displayBusinessNameFetchFailed,
  emailInfoFetched,
  emailInfoFetchFailed,
  emailInfoRequest,
  phoneInfoFetched,
  phoneInfoFetchFailed,
  phoneInfoRequest,
  updateAddressInfoRequest,
  updateAddressInfoFetched,
  updateAddressInfoFetchFailed,
  updateEmailInfoFetched,
  updateEmailInfoFetchFailed,
  updateEmailInfoRequest,
  updatePhoneInfoFetched,
  updatePhoneInfoFetchFailed,
  updatePhoneInfoRequest,
  updatePreferredLangInfoRequest,
  updatePreferredLangInfoFetched,
  updatePreferredLangInfoFetchFailed,
  statementPrefFetched,
  statementPrefFetchFailed,
  updateStatementPrefFetched,
  updateStatementPrefFetchFailed,
  statementPrefRequest,
  updateStatementPrefRequest,
  secureMessageRequest,
  secureMessageFetched,
  secureMessageFetchFailed,
  updateSecureMessageRequest,
  updateSecureMessageFetched,
  updateSecureMessageFetchFailed,
  secureMessageOptionsFetched,
  secureMessageOptionsFetchFailed,
  secureMessageOptionsRequest,
  secureMessageDetailsRequest,
  secureMessageDetailsFetched,
  secureMessageDetailsFetchFailed,
} from '../reducer/contactInfoSlice';
import { setProvinceCode } from '../reducer/userLocationSlice';

interface AccountRequestAction {
  type: typeof contactInfoRequest.type;
  payload: string;
}

export function* fetchDisplayBusinessNameSaga(action) {
  try {
    const { accountId } = action.payload;
    const response = yield call(
      fetchDisplayBusinessName,
      'display_business_name',
      accountId
    );
    if (response.statusCode === '200' && response.accountInformation.customerList.length > 0) {
      yield put(displayBusinessNameFetched(response.accountInformation.customerList[0].name.nameOnCard)); // business name available
    } else {
      yield put(displayBusinessNameFetchFailed(null)); //no business name available
    }
  } catch (error: any) {
    yield put(displayBusinessNameFetchFailed(null)); //no business name available
  }
}

export function* fetchContactInfoSaga(action) {
  try {
    const { accountId, primaryCustomerId, customerId } = action.payload;
    const response = yield call(
      fetchContactPreferences,
      'contactPreferences',
      accountId,
      primaryCustomerId,
      customerId
    );
    if (response.statusCode === '200') {
      yield put(contactInfoFetched(response));
      yield put(setProvinceCode(response?.address?.areaLevelOne?.code ?? null));
    } else {
      yield put(contactInfoFetchFailed(response || 'Something went wrong'));
    }
  } catch (error: any) {
    yield put(contactInfoFetchFailed(error.message || 'Something went wrong'));
  }
}

export function* fetchAddressInfoSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    const response = yield call(
      fetchAddressDetails,
      'address_details',
      accountId,
      customerId
    );
    if (response.statusCode === '200') {
      yield put(addressInfoFetched(response));
    } else {
      yield put(addressInfoFetchFailed(response || 'Something went wrong'));
    }
  } catch (error: any) {
    yield put(addressInfoFetchFailed(error.message || 'Something went wrong'));
  }
}

export function* updateAddressInfoSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;
    const response = yield call(
      updateAddressDetails,
      'update_address_details',
      accountId,
      customerId,
      requestBody
    );
    if (response.statusCode === '200') {
      yield put(updateAddressInfoFetched(response));
    } else {
      yield put(
        updateAddressInfoFetchFailed(response || 'Something went wrong')
      );
    }
  } catch (error: any) {
    yield put(
      updateAddressInfoFetchFailed(error|| 'Something went wrong')
    );
  }
}

export function* fetchPhoneInfoSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    const response = yield call(
      fetchPhoneDetails,
      'phone_details',
      accountId,
      customerId
    );
    if (response.statusCode === '200') {
      yield put(phoneInfoFetched(response));
    } else {
      yield put(phoneInfoFetchFailed(response || 'Something went wrong'));
    }
  } catch (error: any) {
    yield put(phoneInfoFetchFailed(error.message || 'Something went wrong'));
  }
}

export function* updatePhoneInfoSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    const response = yield call(
      updatePhoneDetails,
      'update_phone_details',
      accountId,
      customerId,
      requestBody
    );
    if (response.statusCode === '200') {
      yield put(updatePhoneInfoFetched(response));
    } else {
      yield put(
        updatePhoneInfoFetchFailed(response || 'Something went wrong')
      );
    }
  } catch (error: any) {
    yield put(
      updatePhoneInfoFetchFailed(error || 'Something went wrong')
    );
  }
}

export function* fetchEmailInfoSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    const response = yield call(
      fetchEmailDetails,
      'email_details',
      accountId,
      customerId
    );
    if (response.statusCode === '200') {
      yield put(emailInfoFetched(response));
    } else {
      yield put(emailInfoFetchFailed(response || 'Something went wrong'));
    }
  } catch (error: any) {
    yield put(emailInfoFetchFailed(error.message || 'Something went wrong'));
  }
}

export function* updateEmailInfoSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    const response = yield call(
      updateEmailDetails,
      'update_email_details',
      accountId,
      customerId,
      requestBody
    );
    if (response.statusCode === '200') {
      yield put(updateEmailInfoFetched(response));
    } else {
      yield put(
        updateEmailInfoFetchFailed(response || 'Something went wrong')
      );
    }
  } catch (error: any) {
    console.log('updateEmailInfoSaga', error);
    yield put(
      updateEmailInfoFetchFailed(error.message || 'Something went wrong')
    );
  }
}

export function* updatePreferredLangSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    const response = yield call(
      updatePreferredLangDetails,
      'update_preferredLanguage',
      accountId,
      customerId,
      requestBody
    );
    if (response.statusCode === '200' || response.message === 'Success') {
      yield put(
        updatePreferredLangInfoFetched({
          statusCode: '200',
          message: response.message,
        })
      );
    } else {
      yield put(
        updatePreferredLangInfoFetchFailed(
          response || 'Something went wrong'
        )
      );
    }
  } catch (error: any) {
    console.log('updatePreferredLangSaga', error);
    yield put(
      updatePreferredLangInfoFetchFailed(
        error || 'Something went wrong'
      )
    );
  }
}

export function* fetchStatementPrefSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    const response = yield call(
      fetchStatementPrefDetails,
      'statement_preference',
      accountId,
      customerId
    );
    if (response.statusCode === '200') {
      yield put(statementPrefFetched(response));
    } else {
      yield put(statementPrefFetchFailed(response || 'Something went wrong'));
    }
  } catch (error: any) {
    yield put(
      statementPrefFetchFailed(error.message || 'Something went wrong')
    );
  }
}

export function* updateStatementPrefSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    const response = yield call(
      updateStatementPrefDetails,
      'statement_preference',
      accountId,
      customerId,
      requestBody
    );
    if (response.statusCode === '200') {
      yield put(updateStatementPrefFetched(response));
    } else {
      yield put(
        updateStatementPrefFetchFailed(
          response.message || 'Something went wrong'
        )
      );
    }
  } catch (error: any) {
    console.log('updateStatementPrefSaga', error);
    yield put(
      updateStatementPrefFetchFailed(error.message || 'Something went wrong')
    );
  }
}

export function* fetchSecureMessageSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    const response = yield call(
      fetchSecureMessage,
      'secure_message',
      accountId,
      customerId
    );
    if(response.status == "404"){
    yield put(secureMessageFetchFailed(response));
    }else{
   
    yield put(secureMessageFetched(response));
    }
  } catch (error: any) {
    yield put(
      secureMessageFetchFailed(error.message || 'Something went wrong')
    );
  }
}

export function* fetchSecureMessageDetailsSaga(action) {
  console.log('actionsaga', action);
  try {
    const { accountId, customerId, detailId } = action.payload;
    const response = yield call(
      fetchSecureMessageDetails,
      'secure_message_details',
      accountId,
      customerId,
      detailId
    );
    console.log('response_saga', response);
   
    yield put(secureMessageDetailsFetched(response));
    
  } catch (error: any) {
    yield put(
      secureMessageDetailsFetchFailed(error.message || 'Something went wrong')
    );
  }
}

export function* fetchSecureMessageOptionsSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    const response = yield call(
      fetchSecureMessageOptions,
      'secure_message_options',
      accountId,
      customerId
    );
    if (response.assignmentId) {
      yield put(secureMessageOptionsFetched(response));
    } else {
      yield put(secureMessageOptionsFetchFailed(response));
    }
  } catch (error: any) {
    yield put(
      secureMessageOptionsFetchFailed(error.message || 'Something went wrong')
    );
  }
}

export function* updateSecureMessageSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    const response = yield call(
      updateSecureMessage,
      'secure_message',
      accountId,
      customerId,
      requestBody
    );
    console.log('updateSecureMessageSaga', response);
     if (response.status === "401") {
       yield put(
        updateSecureMessageFetchFailed(
         {
    status: "401",
    detail: " Submit secure message is blocked due to low score",
    title: "RECAPTCHA_ERROR",
    errorCode: "ERR_401_RECAPTCHA_LOW_SCORE"
}
        )
      );
     }
   else if (response.status === '404') {
      yield put(
        updateSecureMessageFetchFailed(
          response.message || 'Something went wrong'
        )
      );
    } else {
      yield put(updateSecureMessageFetched(response));
    }
  } catch (error: any) {
    console.log('updateStatementPrefSaga', error);
    yield put(
      updateSecureMessageFetchFailed(error.message || 'Something went wrong')
    );
  }
}

// Watch sagas
export function* watchContactInfoSagas(): Generator<any, void, unknown> {
  yield takeLatest(displayBusinessNameRequest.type, fetchDisplayBusinessNameSaga);
  yield takeLatest(contactInfoRequest.type, fetchContactInfoSaga);
  yield takeLatest(addressInfoRequest.type, fetchAddressInfoSaga);
  yield takeLatest(phoneInfoRequest.type, fetchPhoneInfoSaga);
  yield takeLatest(emailInfoRequest.type, fetchEmailInfoSaga);
  yield takeLatest(statementPrefRequest.type, fetchStatementPrefSaga);
  yield takeLatest(updateStatementPrefRequest.type, updateStatementPrefSaga);
  yield takeLatest(updateAddressInfoRequest.type, updateAddressInfoSaga);
  yield takeLatest(updateEmailInfoRequest.type, updateEmailInfoSaga);
  yield takeLatest(updatePhoneInfoRequest.type, updatePhoneInfoSaga);
  yield takeLatest(
    updatePreferredLangInfoRequest.type,
    updatePreferredLangSaga
  );
  yield takeLatest(secureMessageRequest.type, fetchSecureMessageSaga);
  yield takeLatest(
    secureMessageOptionsRequest.type,
    fetchSecureMessageOptionsSaga
  );
  yield takeLatest(updateSecureMessageRequest.type, updateSecureMessageSaga);
  yield takeLatest(
    secureMessageDetailsRequest.type,
    fetchSecureMessageDetailsSaga
  );
}
